import { CustomWallpapersState, Wallpaper } from './types';

export const selectCustomWallpaper = (state: {
  customWallpapers: CustomWallpapersState;
}): Wallpaper | null => state.customWallpapers.customWallpaper;
